import { Cita } from '../services/citasService';

export type ReservationStatus = 'upcoming' | 'in-progress' | 'completed' | 'cancelled';
export const isReservationCancelled = (c: Pick<Cita, 'estado' | 'estado_ejecucion'>): boolean =>
  [c.estado, c.estado_ejecucion].some(value => value?.toLowerCase() === 'cancelada');
const instant = (date?: string | null, time?: string | null): number =>
  date ? Date.parse(`${date}T${time || '00:00:00'}-04:00`) : NaN;
export const reservationStatus = (c: Cita, now = Date.now()): ReservationStatus => {
  if (isReservationCancelled(c)) return 'cancelled';
  const start = instant(c.fecha_inicio, c.hora_inicio);
  const end = instant(c.fecha_fin || c.fecha_inicio, c.hora_fin);
  if (Number.isFinite(end) && now >= end) return 'completed';
  if (Number.isFinite(start) && now >= start) return 'in-progress';
  return 'upcoming';
};
export const sortReservations = (citas: Cita[], now = Date.now()): Cita[] => {
  const rank = { 'in-progress': 0, upcoming: 1, completed: 2, cancelled: 3 };
  return [...citas].sort((a, b) => {
    const sa = reservationStatus(a, now), sb = reservationStatus(b, now);
    const order = rank[sa] - rank[sb];
    if (order) return order;
    const difference = (instant(a.fecha_inicio, a.hora_inicio) || 0) - (instant(b.fecha_inicio, b.hora_inicio) || 0);
    return sa === 'completed' || sa === 'cancelled' ? -difference : difference;
  });
};
export const canClientCancel = (c: Cita, userId?: number): boolean =>
  c.cliente === userId && !isReservationCancelled(c) && Number(c.monto_pagado || 0) === 0 && c.estado_pago === 'Pendiente';
